/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerLocationDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get all locations for the current customer
 * @summary Get customer locations
 */
export const getCustomerLocations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerLocationDTO[]>(
      {url: `/api/frontend/admin/customer-locations`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomerLocationsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/admin/customer-locations`
    ] as const;
    }

export const getGetCustomerLocationsQueryKey = () => {
    return [
    `/api/frontend/admin/customer-locations`
    ] as const;
    }

    
export const getGetCustomerLocationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocations>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerLocationsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerLocations>>> = ({ signal }) => getCustomerLocations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerLocationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerLocations>>>
export type GetCustomerLocationsInfiniteQueryError = unknown


export function useGetCustomerLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocations>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer locations
 */

export function useGetCustomerLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerLocationsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerLocations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerLocationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerLocations>>> = ({ signal }) => getCustomerLocations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerLocations>>>
export type GetCustomerLocationsQueryError = unknown


export function useGetCustomerLocations<TData = Awaited<ReturnType<typeof getCustomerLocations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocations<TData = Awaited<ReturnType<typeof getCustomerLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocations<TData = Awaited<ReturnType<typeof getCustomerLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer locations
 */

export function useGetCustomerLocations<TData = Awaited<ReturnType<typeof getCustomerLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerLocationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create or update a customer location
 * @summary Save customer location
 */
export const saveCustomerLocation = (
    customerLocationDTO: CustomerLocationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerLocationDTO>(
      {url: `/api/frontend/admin/customer-locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerLocationDTO, signal
    },
      options);
    }
  


export const getSaveCustomerLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveCustomerLocation>>, TError,{data: CustomerLocationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveCustomerLocation>>, TError,{data: CustomerLocationDTO}, TContext> => {

const mutationKey = ['saveCustomerLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveCustomerLocation>>, {data: CustomerLocationDTO}> = (props) => {
          const {data} = props ?? {};

          return  saveCustomerLocation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveCustomerLocationMutationResult = NonNullable<Awaited<ReturnType<typeof saveCustomerLocation>>>
    export type SaveCustomerLocationMutationBody = CustomerLocationDTO
    export type SaveCustomerLocationMutationError = unknown

    /**
 * @summary Save customer location
 */
export const useSaveCustomerLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveCustomerLocation>>, TError,{data: CustomerLocationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveCustomerLocation>>,
        TError,
        {data: CustomerLocationDTO},
        TContext
      > => {

      const mutationOptions = getSaveCustomerLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get locations for the current customer by address type
 * @summary Get customer locations by type
 */
export const getCustomerLocationsByType = (
    addressType: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerLocationDTO[]>(
      {url: `/api/frontend/admin/customer-locations/${addressType}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomerLocationsByTypeInfiniteQueryKey = (addressType?: string,) => {
    return [
    'infinite', `/api/frontend/admin/customer-locations/${addressType}`
    ] as const;
    }

export const getGetCustomerLocationsByTypeQueryKey = (addressType?: string,) => {
    return [
    `/api/frontend/admin/customer-locations/${addressType}`
    ] as const;
    }

    
export const getGetCustomerLocationsByTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocationsByType>>>, TError = unknown>(addressType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerLocationsByTypeInfiniteQueryKey(addressType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerLocationsByType>>> = ({ signal }) => getCustomerLocationsByType(addressType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(addressType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerLocationsByTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerLocationsByType>>>
export type GetCustomerLocationsByTypeInfiniteQueryError = unknown


export function useGetCustomerLocationsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocationsByType>>>, TError = unknown>(
 addressType: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocationsByType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocationsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocationsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocationsByType>>>, TError = unknown>(
 addressType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocationsByType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocationsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocationsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocationsByType>>>, TError = unknown>(
 addressType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer locations by type
 */

export function useGetCustomerLocationsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerLocationsByType>>>, TError = unknown>(
 addressType: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerLocationsByTypeInfiniteQueryOptions(addressType,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerLocationsByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError = unknown>(addressType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerLocationsByTypeQueryKey(addressType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerLocationsByType>>> = ({ signal }) => getCustomerLocationsByType(addressType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(addressType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerLocationsByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerLocationsByType>>>
export type GetCustomerLocationsByTypeQueryError = unknown


export function useGetCustomerLocationsByType<TData = Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError = unknown>(
 addressType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocationsByType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocationsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocationsByType<TData = Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError = unknown>(
 addressType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerLocationsByType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerLocationsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerLocationsByType<TData = Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError = unknown>(
 addressType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer locations by type
 */

export function useGetCustomerLocationsByType<TData = Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError = unknown>(
 addressType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerLocationsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerLocationsByTypeQueryOptions(addressType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete a customer location by address type
 * @summary Delete customer location
 */
export const deleteCustomerLocation = (
    addressType: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/frontend/admin/customer-locations/${addressType}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCustomerLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerLocation>>, TError,{addressType: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerLocation>>, TError,{addressType: string}, TContext> => {

const mutationKey = ['deleteCustomerLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerLocation>>, {addressType: string}> = (props) => {
          const {addressType} = props ?? {};

          return  deleteCustomerLocation(addressType,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerLocation>>>
    
    export type DeleteCustomerLocationMutationError = unknown

    /**
 * @summary Delete customer location
 */
export const useDeleteCustomerLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerLocation>>, TError,{addressType: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerLocation>>,
        TError,
        {addressType: string},
        TContext
      > => {

      const mutationOptions = getDeleteCustomerLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    